<template>
    <div>
        <v-container class="mt-4 pa-5 mb-5">
            <v-row dense v-if="headerView && refresh">
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-data-table :headers="headers" :items="account_hdr" class="elevation-1" hide-default-footer>
                        <template v-for="header in headers.filter((header) =>
                            header.hasOwnProperty('formatter')
                        )" v-slot:[`item.${header.value}`]="{ header, value }">
                            {{ header.formatter(value) }}
                        </template>
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>STUDENT ACCOUNTS</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn small elevation="2" @click="ViewDetails(item.termcd)">
                                <v-icon left small class="mr-2">
                                    mdi-pencil
                                </v-icon>
                                View Details
                            </v-btn>

                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row dense v-else>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-data-table :headers="headerDetail" :items="account_dtl" class="elevation-1" hide-default-footer>
                        <template v-for="header in headerDetail.filter((header) =>
                            header.hasOwnProperty('formatter')
                        )" v-slot:[`item.${header.value}`]="{ header, value }">
                            {{ header.formatter(value) }}
                        </template>
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>STATEMENT OF ACCOUNT</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-btn class="font-weight-bold mr-2" color="green darken-4" dark small
                                    @click="GetAccounts">
                                    <v-icon small left class="mr-2">
                                        mdi-arrow-left
                                    </v-icon>
                                    Back
                                </v-btn>
                                <v-btn class="font-weight-bold" color="green darken-4" dark small @click="print">
                                    <v-icon small left class="mr-2">
                                        mdi-printer
                                    </v-icon>
                                    Print
                                </v-btn>
                            </v-toolbar>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import studentService from '@/services/student'
import numeral from 'numeral';
import moment from 'moment';

export default {
    name: 'StudentAccounts',
    props: ['student','refresh'],
    data() {
        return {
        account_hdr: [],
        account_dtl: [],
        headerView: true,
        }
    },
    computed: {
        headers () { 
            return [
                { text: 'ROW', align: 'start', 'sortable': false, value: 'row' },
                { text: 'Term', value: 'term' },
                { text: 'Account', value: 'account' },
                { text: 'Debit', value: 'debit', formatter: (x) => (x ? this.formatExample(x) : ''), align: 'right', class: 'mr-1' },
                { text: 'Credit', value: 'credit', formatter: (x) => (x ? this.formatExample(x) : ''), align: 'right', class: 'mr-1' },
                { text: 'Balance', value: 'balance', formatter: (x) => (x ? this.formatExample(x) : ''), align: 'right', class: 'mr-1' },
                { text: 'Program Id', value: 'program_id', align: 'center'},
                { text: 'Action', value: 'actions', sortable: false, align: 'center' },
                { text: 'termcd', value: 'termcd', align: ' d-none'}
            ]
        },
        headerDetail () {
            return [
                { text: 'Tran Date', value: 'tran_date' },
                { text: 'Reference', value: 'refno' },
                { text: 'Particulars', value: 'particular' },
                { text: 'Debit', value: 'debit', formatter: (x) => (x ? this.formatExample(x) : ''), align: 'right', class: 'mr-1' },
                { text: 'Credit', value: 'credit', formatter: (x) => (x ? this.formatExample(x) : ''), align: 'right', class: 'mr-1' },
                { text: 'Balance', value: 'balance', formatter: (x) => (x ? this.formatExample(x) : ''), align: 'right', class: 'mr-1' },
            
            ]
        }
    },
    mounted() {
        this.GetAccounts()
    },
    methods: {
        formatExample(value) {

            if (value >= 0) {
                return numeral(value).format('0,0.00')
            } else {
                if (typeof value !== 'string') {
                    value = value * -1

                    return '(' + numeral(value).format('0,0.00') + ')'
                } else {
                    return numeral(value).format('0,0.00')
                }
            }


        },
        async GetAccounts() {
            try {
                this.headerView = true
                const result = await studentService.GetAccounts(this.student.stud_no);
                if (result.data.success) {
                    let data = [];
                    this.account_hdr = [];
                    if (result.data.data.length > 0) {
                          result.data.data.forEach((value, index) => {
                            data = [];
                            data = {
                                row: index + 1,
                                term: this.SetTerm(value.term_cd),
                                account: value.acct_name,
                                debit: parseFloat(value.debit).toFixed(2),
                                credit: parseFloat(value.credit).toFixed(2),
                                balance: parseFloat(value.debit - value.credit).toFixed(2),
                                program_id: value.program_id,
                                termcd: value.term_cd

                            }

                            this.account_hdr.push(data);
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        SetTerm(termcd) {
            const tt = termcd.toString().substring(6,4)
            const year = termcd.toString().substring(0,4)
            const endyear = parseInt(year) + 1
            let term
            switch (tt) {
                case '00':
                    term = 'School year ' + year + ' - ' + endyear
                    break;
                case '21':
                    term = '1st Semester ' + year + ' - ' + endyear
                    break;
                case '22':
                    term = '2nd Semester ' + year + ' - ' + endyear
                    break;
                case '23':
                    term = 'Summer ' + endyear
                    break;
                case '31':
                    term = '1st Trimester ' + year
                    break;
                case '32':
                    term = '2nd Trimester ' + year
                    break;
                case '33':
                    term = '3rd Trimester ' + year
                    break;
                case '34':
                    term = '4th Trimester ' + year
                    break;
                case '41':
                    term = '1st Quarter ' + year
                    break;
                case '42':
                    term = '2nd Quarter ' + year
                    break;
                case '43':
                    term = '3rd Quarter ' + year
                    break;
                case '44':
                    term = '4th Quarter ' + year
                    break;
                default:
                    break;
            }
            return term
        },
        async ViewDetails(val) {
            try {
                this.headerView = false
                const result = await studentService.GetStudentAccountsDetails({
                    studentNo: this.student.stud_no,
                    term: val
                })
                if (result.status === 200) {
                    this.account_dtl = []
                    let balance = 0
                    result.data.data.forEach((value, index) => {
                        let data = []

                        if (value.term_cd === val) {
                            balance += value.debit - value.credit
                            
                            data = {
                                tran_date: moment(value.tran_dt).format('YYYY-MM-DD hh:mm A'),
                                refno: value.refno,
                                particular: value.particulars,
                                debit: parseFloat(value.debit || 0).toFixed(2),
                                credit: parseFloat(value.credit || 0).toFixed(2),
                                balance: parseFloat(balance || 0).toFixed(2)
                            }

                            this.account_dtl.push(data)
                        }
                       
                    })
                }
                
            } catch (error) {
                console.log(error)
            }
        },
        print() {

        }
    }
}
</script>
